import React, { useState } from 'react';

const NoDataError = ({ text, colspn}) => {
    const [defaultText] = useState("No data available");
    return (
        <>
        {!!colspn ?
        <tr>
        <td colSpan={colspn}>
        <div className="no-data-available-style">{text ? text : defaultText}</div>
        </td>
     </tr>    
     :
        <div className="no-data-available-style">{text ? text : defaultText}</div>
    }
        </>
    )
}

export default NoDataError;